import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import _classCallCheck from "/home/abhay/Projects/kalalaya-academy/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/abhay/Projects/kalalaya-academy/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/abhay/Projects/kalalaya-academy/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/abhay/Projects/kalalaya-academy/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/abhay/Projects/kalalaya-academy/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module paragraph/paragraphcommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
import first from '@ckeditor/ckeditor5-utils/src/first';
/**
 * The paragraph command.
 *
 * @extends module:core/command~Command
 */

var ParagraphCommand =
/*#__PURE__*/
function (_Command) {
  _inherits(ParagraphCommand, _Command);

  function ParagraphCommand() {
    _classCallCheck(this, ParagraphCommand);

    return _possibleConstructorReturn(this, _getPrototypeOf(ParagraphCommand).apply(this, arguments));
  }

  _createClass(ParagraphCommand, [{
    key: "refresh",

    /**
     * The value of the command. Indicates whether the selection start is placed in a paragraph.
     *
     * @readonly
     * @observable
     * @member {Boolean} #value
     */

    /**
     * @inheritDoc
     */
    value: function refresh() {
      var model = this.editor.model;
      var document = model.document;
      var block = first(document.selection.getSelectedBlocks());
      this.value = !!block && block.is('paragraph');
      this.isEnabled = !!block && checkCanBecomeParagraph(block, model.schema);
    }
    /**
     * Executes the command. All the blocks (see {@link module:engine/model/schema~Schema}) in the selection
     * will be turned to paragraphs.
     *
     * @fires execute
     * @param {Object} [options] Options for the executed command.
     * @param {module:engine/model/selection~Selection|module:engine/model/documentselection~DocumentSelection} [options.selection]
     * The selection that the command should be applied to.
     * By default, if not provided, the command is applied to the {@link module:engine/model/document~Document#selection}.
     */

  }, {
    key: "execute",
    value: function execute() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var model = this.editor.model;
      var document = model.document;
      model.change(function (writer) {
        var blocks = (options.selection || document.selection).getSelectedBlocks();
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = blocks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var block = _step.value;

            if (!block.is('paragraph') && checkCanBecomeParagraph(block, model.schema)) {
              writer.rename(block, 'paragraph');
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    }
  }]);

  return ParagraphCommand;
}(Command); // Checks whether the given block can be replaced by a paragraph.
//
// @private
// @param {module:engine/model/element~Element} block A block to be tested.
// @param {module:engine/model/schema~Schema} schema The schema of the document.
// @returns {Boolean}


export { ParagraphCommand as default };

function checkCanBecomeParagraph(block, schema) {
  return schema.checkChild(block.parent, 'paragraph') && !schema.isObject(block);
}